import React from 'react';
import { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';

import apiCall from '../utilities/auth/apiCall';
import { resetPasswordEmail } from '../utilities/auth/authApi';
import { isAuthed } from "../utilities/auth/tokenHelpers";
import FormErrorMessage from '../utilities/formErrorMessage';


function ForgotPassword() {

  // Define variables
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');


  // Component load actions
  useEffect(() => {

    // Redirect if already logged in
    const isLoggedIn = isAuthed();
    if( isLoggedIn ) {
      navigate("/dashboard");
    }

  }, []);


  // Define functions
  function handleFormSubmit(event) {
    event.preventDefault();

    setButtonDisabled(true);
    setErrorMessage('');

    const payload = {
      email: email
    }

    apiCall(resetPasswordEmail, payload).then((response) => {
      if( response.success ) {
        setSuccessMessage('Check your email for password reset instructions.');
      } else {
        setErrorMessage(response.error);
        setButtonDisabled(false);
      }
    });

  }


  // Screen components
  let activeElement = (
    <form class='form' onSubmit={(event) => handleFormSubmit(event)}>
      <div class='input-label'>
        <input
          type='text'
          onChange={(event) => setEmail(event.target.value)}
          value={email}
          placeholder='Email address'
          required
        />
      </div>

      <div class='input-label'>
        <button
          type='submit'
          class='button'
          disabled={buttonDisabled}
        >Send Password Reset Instructions</button>
      </div>
    </form>
  );

  if( successMessage ) {
    activeElement = (
      <p>{successMessage}</p>
    );
  }



  return (
    <div class='flex-column' style={{height: '100vh'}}>

      <header class='flex-row'>
        <div class='logo-square'></div>
        <h1>Dia Daily</h1>
      </header>

      <section class='body-content'>

        <h1>Forgot Password</h1>

        <FormErrorMessage message={errorMessage} />

        <div class='active-element-container'>
          {activeElement}
        </div>

        <br /><br /><br />
        <Link to='/login' class='sub-text'>Login</Link>
        <span>&nbsp;&nbsp;</span>|<span>&nbsp;&nbsp;</span>
        <Link to='/register' class='sub-text'>Register</Link>
      </section>
    </div>
  );
}

export default ForgotPassword;